export interface BonusFormErrors {
    amount?: string;
}

export function validateBonus(amount: number | null): BonusFormErrors {
    const errors: BonusFormErrors = {};

    if (!amount || amount <= 0) {
        errors.amount = 'Enter a bonus amount greater than $0.';
    }

    return errors;
}
